// Brand: Milano

import React from 'react';

import withAppState from '../../mobx/withAppState'
import { Steps } from '../../lib/constants';
import PayAtTableRestaurantSearchWrapper from '../../wrappers/Milano/PayAtTable/RestaurantSearchWrapper';
import MenuOnlyRestaurantSearchWrapper from '../../wrappers/Milano/MenuOnly/RestaurantSearchWrapper';
import TablePickerWrapper from '../../wrappers/Milano/PayAtTable/TablePickerWrapper';
import BillWrapper from '../../wrappers/Milano/PayAtTable/BillWrapper';
import SplitBillMenuWrapper from '../../wrappers/Milano/PayAtTable/SplitBillMenuWrapper';
import SplitBillNameWrapper from '../../wrappers/Milano/PayAtTable/SplitBillNameWrapper';
import ApplyGratuityWrapper from '../../wrappers/Milano/PayAtTable/ApplyGratuityWrapper'
import ApplyVoucherWrapper from '../../wrappers/Milano/PayAtTable/ApplyVoucherWrapper';
import PayWrapper from '../../wrappers/Milano/PayAtTable/PayWrapper';
import PaymentConfirmationWrapper from '../../wrappers/Milano/PayAtTable/PaymentConfirmationWrapper';
import MenuWrapper from '../../wrappers/Milano/MenuOnly/MenuWrapper';
import DataCaptureWrapper from '../../wrappers/Milano/MenuOnly/DataCaptureWrapper';

import '../../styles/PizzaExpress/App.css';
import '../../styles/PizzaExpress/TopBanner.css';


const Flow = (props) => {
  const { activeStep, isOrderJourney } = props;

  const defaultStep = () => {
    if (isOrderJourney) return <MenuWrapper />;
    return <PayAtTableRestaurantSearchWrapper />;
  }
  
  
  return (
    <>
      {(activeStep === Steps.DEFAULT) && defaultStep()}
      {activeStep === Steps.RESTAURANT_SEARCH && <PayAtTableRestaurantSearchWrapper />}
      {activeStep === Steps.PRE_ORDER && <MenuWrapper />}
      {activeStep === Steps.PRE_ORDER_DATA_CAPTURE && <DataCaptureWrapper />}
      {activeStep === Steps.TABLE_PICKER && <TablePickerWrapper />}
      {activeStep === Steps.BILL && <BillWrapper />}
      {activeStep === Steps.SPLIT_BILL_MENU && <SplitBillMenuWrapper />}
      {activeStep === Steps.SPLIT_BILL_NAME && <SplitBillNameWrapper />}
      {activeStep === Steps.APPLY_VOUCHER && <ApplyVoucherWrapper />}
      {activeStep === Steps.APPLY_GRATUITY && <ApplyGratuityWrapper />}
      {activeStep === Steps.PAY && <PayWrapper />}
      {activeStep === Steps.PAYMENT_CONFIRMATION && <PaymentConfirmationWrapper />}
    </>
  );
}

export default withAppState(Flow,
  {
    mobXProps: ({
      activeStep,
      isOrderJourney,
      restaurant,
    }) => ({
      activeStep,
      isOrderJourney,
      restaurant,
    }),
  }
);